module.exports = __webpack_public_path__ + "static/img/logo.4544c294.png";